import './StarsDisplay.scss'

import { InternalComponentAPI } from '../../utils/types'
import { setChildAttribute } from '../../utils/dom'
import { withAttrib } from '../../utils/selectors'

const RATING_VALUE_DATA_ATTRIB = 'data-rating-value'

interface StarsDisplayProps {
  target: Element
  rating: number
}
export interface StarsDisplayInternalComponentAPI extends Pick<InternalComponentAPI, 'destroy'> {
  updateRating(rating: number): void
}

const StarsDisplay = ({
  target,
  rating
}: StarsDisplayProps): StarsDisplayInternalComponentAPI => {
  target.innerHTML = starsComponent(rating)

  return {
    updateRating: (rating: number) => {
      setChildAttribute({
        parent: target,
        selector: withAttrib(RATING_VALUE_DATA_ATTRIB),
        attributeName: RATING_VALUE_DATA_ATTRIB,
        attributeValue: `${roundToQuarter(rating)}`
      })
    },
    destroy: () => (target.innerHTML = '')
  }
}

const starsComponent = (rating: number) => `
  <div
    class="star-display"
    data-testid="star-display"
    ${RATING_VALUE_DATA_ATTRIB}="${roundToQuarter(rating)}"
  >
    <div>1</div>
    <div>2</div>
    <div>3</div>
    <div>4</div>
    <div>5</div>
  </div>
`

const roundToQuarter = (rating: number) => {
  const intRating = Math.round(rating * 100)
  return Math.round(intRating / 25) * 0.25
}

export default StarsDisplay
